<div class="ui vertical segment" id="scroll-container">
  <div class="ui secondary sub pointing menu" appMargin marginB="4">
    <div
      class="ui item"
      [routerLink]="['/contractor/company/document/official']"
      routerLinkActive="active"
      [queryParams]="{ documentStatus: 'verified' }"
    >
      Verified
      <div class="ui blue label mini circular">{{ getVerifiedCount() }}</div>
    </div>
    <div
      class="ui item"
      [routerLink]="['/contractor/company/document/official']"
      routerLinkActive="active"
      [queryParams]="{ documentStatus: 'pending' }"
    >
      Pending Verification
      <div class="ui blue label mini circular">
        {{ pendingDocuments ? "1" : "0" }}
      </div>
    </div>
    <div
      class="ui item"
      [routerLink]="['/contractor/company/document/official']"
      routerLinkActive="active"
      [queryParams]="{ documentStatus: 'archive' }"
    >
      Archive
      <div class="ui blue label mini circular">{{ getArchivedCount() }}</div>
    </div>

    <div
      class="ui item"
      [routerLink]="['/contractor/company/document/official']"
      routerLinkActive="active"
      [queryParams]="{ documentStatus: 'history' }"
    >
      History
      <div class="ui blue label mini circular">
        {{ historyDocuments?.length }}
      </div>
    </div>
  </div>
  <div
    class="ui vertical basic segment"
    [ngClass]="{ loading: pending }"
    appMargin="0"
    appPadding="0"
  >
    <div
      *ngIf="documentStatus != 'history'"
      class=""
      style="overflow-x: hidden"
    >
      <div
        *ngIf="filterDocuments && filteredDocuments?.length < 1"
        style="width: 50%; margin: 0 auto"
        class="no-record"
      >
        <h3
          style="
            font-size: 18px;
            font-weight: 700;
            margin-top: 2.5rem;
            text-align: center;
          "
        >
          This section has no uploaded document
        </h3>
        <p
          style="
            font-size: 14px;
            font-weight: 400;
            margin-top: 16px;
            text-align: center;
          "
          *ngIf="documentStatus === 'verified'"
        >
          Click the upload button below to upload the required document.
        </p>
        <button
          style="
            background-color: #3f4395;
            color: #fff;
            font-weight: 400;
            position: relative;
            left: 11rem;
          "
          class="ui primary button"
          *ngIf="documentStatus === 'verified'"
          (click)="uploadDoc.emit(documentTypeId)"
        >
          Upload
        </button>
      </div>
      <div
        *ngIf="documentStatus == 'pending' && pendingDocuments"
        class="ui message"
        style="
          background-color: #fff5ea;
          display: flex;
          padding: 8px 16px;
          color: #505050;
          margin-top: 0;
          height: 36px;
          align-items: center;
        "
      >
        <h6 style="font-size: 10px; font-weight: 400">
          <span style="margin-right: 9px; margin-left: 5px; margin-top: 3px">
            <svg
              style="position: relative; top: 0.2rem"
              width="15"
              height="15"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 7.5V10.625M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 13.125H10.0063V13.1313H10V13.125Z"
                stroke="#FFAC33"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              /></svg></span
          >The document(s) you've submitted for verification will be visible
          under the verified tab upon NCC's approval.
        </h6>
      </div>
      <app-advanced-search-filter
        *ngIf="filteredDocuments?.length > 1"
      ></app-advanced-search-filter>
      <div *ngIf="documentStatus == 'pending' && pendingDocuments">
        <div>
          <div
            class="ui basic segment"
            style="padding: 10px 20px; margin-top: -20px"
            appMargin
            marginB="3"
          >
            <h5 style="margin-top: 10px; margin-bottom: 10px; font-weight: 600">
              {{ returnJSON(pendingDocuments?.toValue)?.documentName }}
            </h5>
            <div
              fxLayout="row"
              appPadding
              paddingR="0"
              fxLayoutGap="35px"
              fxLayoutAlign="start"
            >
              <div fxFlex="166px" class="content">
                <div class="top">Date Added</div>
                <div class="bottom">
                  {{
                    pendingDocuments?.dateCreated
                      | date: "d MMM, y h:mm a" || "-"
                  }}
                </div>
              </div>
              <div class="content" style="width: fit-content !important">
                <div class="top">Added By</div>
                <div class="bottom">
                  {{ returnJSON(pendingDocuments?.createdBy)?.name }}
                </div>
              </div>
              <div class="content">
                <div class="top">Status</div>
                <div class="bottom">
                  <label
                    style="font-weight: 300"
                    class="ui tiny circular label"
                    [ngClass]="{
                      'label-green': pendingDocuments?.status == 'VERIFIED',
                      'label-red': pendingDocuments?.status == 'UNVERIFIED',
                      'label-orange': pendingDocuments?.status == 'PENDING',
                      'label-grey': pendingDocuments?.Status == 'DISCARDED'
                    }"
                    >{{ "PENDING VERIFICATION" | uppercase }}
                  </label>
                </div>
              </div>
              <div *ngIf="documentStatus != 'archive'" fxFlex="100px"></div>
              <div *ngIf="documentStatus == 'archive'" fxFlex="130px"></div>
              <div
                fxFlex="120px"
                style="position: absolute; right: 0; bottom: 25px"
                class="content btn-holder"
                fxLayout="row"
                fxLayoutAlign="end center"
                fxLayoutGap="8px"
              >
                <div
                  class="ui circular tiny button"
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="View"
                  *isPermitted="{
                    id: 'COMPANY_DETAILS_DOCUMENT_UPLOAD',
                    action: 'read'
                  }"
                  (click)="history.emit(pendingDocuments)"
                >
                  <span style="left: 5.5px">
                    <svg
                      width="14"
                      height="11"
                      viewBox="0 0 14 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 6.99854C7.99414 6.99854 8.80005 6.19263 8.80005 5.19849C8.80005 4.20435 7.99414 3.39844 7 3.39844C6.00586 3.39844 5.19995 4.20435 5.19995 5.19849C5.19995 6.19263 6.00586 6.99854 7 6.99854Z"
                        fill="#86879D"
                      />
                      <path
                        d="M13.7232 5.04714C13.1939 3.67804 12.275 2.49404 11.0802 1.64148C9.88531 0.788915 8.46681 0.305159 7 0.25C5.53319 0.305159 4.11469 0.788915 2.91983 1.64148C1.72496 2.49404 0.806097 3.67804 0.276809 5.04714C0.241064 5.14601 0.241064 5.25427 0.276809 5.35314C0.806097 6.72224 1.72496 7.90624 2.91983 8.7588C4.11469 9.61136 5.53319 10.0951 7 10.1503C8.46681 10.0951 9.88531 9.61136 11.0802 8.7588C12.275 7.90624 13.1939 6.72224 13.7232 5.35314C13.7589 5.25427 13.7589 5.14601 13.7232 5.04714ZM7 8.12522C6.42147 8.12522 5.85594 7.95367 5.37491 7.63226C4.89388 7.31084 4.51897 6.85401 4.29758 6.31952C4.07618 5.78503 4.01826 5.19689 4.13112 4.62948C4.24399 4.06207 4.52257 3.54087 4.93165 3.13179C5.34073 2.72271 5.86193 2.44413 6.42934 2.33126C6.99676 2.2184 7.58489 2.27632 8.11938 2.49772C8.65387 2.71911 9.11071 3.09402 9.43212 3.57505C9.75353 4.05608 9.92508 4.62161 9.92508 5.20014C9.92389 5.97555 9.61533 6.71887 9.06703 7.26717C8.51873 7.81547 7.77541 8.12403 7 8.12522Z"
                        fill="#86879D"
                      />
                    </svg>
                  </span>
                </div>

                <button
                  class="ui circular tiny button"
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="Download"
                  *isPermitted="{
                    id: 'COMPANY_DETAILS_DOCUMENT_UPLOAD',
                    action: 'read'
                  }"
                  (click)="download.emit(returnJSON(pendingDocuments?.toValue))"
                >
                  <span style="left: 4px">
                    <svg
                      width="16"
                      height="15"
                      viewBox="0 0 16 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 8.34961C8.32361 8.34961 8.58594 8.08729 8.58594 7.76367V0.585938C8.58594 0.262324 8.32361 0 8 0C7.67639 0 7.41406 0.262324 7.41406 0.585938V7.76367C7.41406 8.08729 7.67639 8.34961 8 8.34961Z"
                        fill="#86879D"
                      />
                      <path
                        d="M6.72478 10.7595C6.72578 10.7605 6.72674 10.7615 6.72774 10.7625C7.07054 11.1053 7.52078 11.2766 7.97101 11.2766C8.42089 11.2766 8.87072 11.1055 9.21285 10.7633L12.4565 7.53235C12.6858 7.30398 12.6865 6.93299 12.4581 6.70372C12.2298 6.47447 11.8588 6.47371 11.6295 6.70208L8.38503 9.93387C8.27435 10.0445 8.12722 10.1055 7.97072 10.1055C7.81477 10.1055 7.66811 10.045 7.55757 9.93508L4.37432 6.70586C4.14715 6.47538 3.77614 6.47274 3.54569 6.69991C3.31524 6.92708 3.31257 7.29806 3.53974 7.52854L6.72478 10.7595Z"
                        fill="#86879D"
                      />
                      <path
                        d="M14.9141 12.0703C14.5904 12.0703 14.3281 12.3326 14.3281 12.6562C14.3281 13.3024 13.8024 13.8281 13.1562 13.8281H2.84375C2.19758 13.8281 1.67188 13.3024 1.67188 12.6562C1.67188 12.3326 1.40955 12.0703 1.08594 12.0703C0.762324 12.0703 0.5 12.3326 0.5 12.6562C0.5 13.9486 1.55141 15 2.84375 15H13.1562C14.4486 15 15.5 13.9486 15.5 12.6562C15.5 12.3326 15.2377 12.0703 14.9141 12.0703Z"
                        fill="#86879D"
                      />
                    </svg>
                  </span>
                </button>
                <img
                  src="assets/icons/trash.svg"
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="Delete Request"
                  (click)="removeDocument.emit(pendingDocuments)"
                  style="cursor: pointer"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="ui divider"></div>
        </div>
      </div>
      <div
        *ngIf="documentStatus == 'pending' && !pendingDocuments"
        style="width: 50%; margin: 0 auto"
        class="no-record"
      >
        <h3
          style="
            font-size: 18px;
            font-weight: 700;
            margin-top: 2.5rem;
            text-align: center;
          "
        >
          This section has no uploaded document
        </h3>
      </div>
      <div *ngIf="documentStatus !== 'pending'">
        <div *ngFor="let document of filteredDocuments">
          <div
            class="ui basic segment"
            style="padding: 10px 20px; margin-top: -20px"
            appMargin
            marginB="3"
          >
            <h5 style="margin-top: 10px; margin-bottom: 10px; font-weight: 600">
              {{ document?.documentId?.documentName }}
            </h5>
            <div
              fxLayout="row"
              appPadding
              paddingR="0"
              fxLayoutGap="35px"
              fxLayoutAlign="start"
            >
              <div fxFlex="166px" class="content">
                <div class="top">Date Added</div>
                <div class="bottom">
                  {{ document?.dateCreated | date: "d MMM, y h:mm a" || "-" }}
                </div>
              </div>
              <div class="content" style="width: fit-content !important">
                <div class="top">Added By</div>
                <div class="bottom">
                  {{ returnJSON(document?.createdBy)?.name }}
                </div>
              </div>
              <div
                *ngIf="documentStatus != 'archive'"
                fxFlex="67px"
                class="content"
              >
                <div class="top">Status</div>
                <div class="bottom">
                  <label
                    style="font-weight: 300"
                    class="ui tiny circular label"
                    [ngClass]="{
                      'label-green':
                        document?.verificationStatus == 'VERIFIED' ||
                        document?.status == 'ACTIVE',
                      'label-red': document?.verificationStatus == 'FAILED',
                      'label-orange': document?.verificationStatus == 'PENDING',
                      'label-grey':
                        document?.verificationStatus == null &&
                        document?.status !== 'ACTIVE'
                    }"
                    >{{
                      (document.verificationStatus
                        ? document.verificationStatus === "VERIFIED"
                          ? "VERIFIED"
                          : document.verificationStatus
                        : document.status === "ACTIVE"
                        ? "VERIFIED"
                        : ""
                      ) | uppercase
                    }}
                  </label>
                </div>
              </div>
              <div *ngIf="documentStatus != 'archive'" fxFlex="100px"></div>
              <div *ngIf="documentStatus == 'archive'" fxFlex="130px"></div>
              <div
                fxFlex="120px"
                style="position: absolute; right: 0; bottom: 25px"
                class="content btn-holder"
                fxLayout="row"
                fxLayoutAlign="end center"
                fxLayoutGap="8px"
              >
                <div
                  class="ui circular tiny button"
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="View"
                  *isPermitted="{
                    id: 'COMPANY_DETAILS_DOCUMENT_UPLOAD',
                    action: 'read'
                  }"
                  (click)="onView.emit(document)"
                >
                  <span style="left: 5.5px">
                    <svg
                      width="14"
                      height="11"
                      viewBox="0 0 14 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 6.99854C7.99414 6.99854 8.80005 6.19263 8.80005 5.19849C8.80005 4.20435 7.99414 3.39844 7 3.39844C6.00586 3.39844 5.19995 4.20435 5.19995 5.19849C5.19995 6.19263 6.00586 6.99854 7 6.99854Z"
                        fill="#86879D"
                      />
                      <path
                        d="M13.7232 5.04714C13.1939 3.67804 12.275 2.49404 11.0802 1.64148C9.88531 0.788915 8.46681 0.305159 7 0.25C5.53319 0.305159 4.11469 0.788915 2.91983 1.64148C1.72496 2.49404 0.806097 3.67804 0.276809 5.04714C0.241064 5.14601 0.241064 5.25427 0.276809 5.35314C0.806097 6.72224 1.72496 7.90624 2.91983 8.7588C4.11469 9.61136 5.53319 10.0951 7 10.1503C8.46681 10.0951 9.88531 9.61136 11.0802 8.7588C12.275 7.90624 13.1939 6.72224 13.7232 5.35314C13.7589 5.25427 13.7589 5.14601 13.7232 5.04714ZM7 8.12522C6.42147 8.12522 5.85594 7.95367 5.37491 7.63226C4.89388 7.31084 4.51897 6.85401 4.29758 6.31952C4.07618 5.78503 4.01826 5.19689 4.13112 4.62948C4.24399 4.06207 4.52257 3.54087 4.93165 3.13179C5.34073 2.72271 5.86193 2.44413 6.42934 2.33126C6.99676 2.2184 7.58489 2.27632 8.11938 2.49772C8.65387 2.71911 9.11071 3.09402 9.43212 3.57505C9.75353 4.05608 9.92508 4.62161 9.92508 5.20014C9.92389 5.97555 9.61533 6.71887 9.06703 7.26717C8.51873 7.81547 7.77541 8.12403 7 8.12522Z"
                        fill="#86879D"
                      />
                    </svg>
                  </span>
                </div>
                <div
                  style="margin-right: 5px; display: flex"
                  *ngIf="document?.verificationStatus == 'VERIFIED'"
                >
                  <button
                    *isPermitted="{
                      id: 'COMPANY_DETAILS_DOCUMENT_UPLOAD',
                      action: 'remove'
                    }"
                    style="margin-right: 8.5px"
                    class="ui circular tiny button"
                    suiPopup
                    [popupInverted]="true"
                    style="top: 2px"
                    popupPlacement="bottom"
                    [popupText]="
                      documentStatus == 'archive' ? 'unarchive' : 'archive'
                    "
                    (click)="
                      documentStatus == 'archive'
                        ? removeArchive.emit(document)
                        : onArchive.emit(document)
                    "
                  >
                    <span style="top: 7px; left: 8px">
                      <svg
                        width="8"
                        height="9"
                        viewBox="0 0 8 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7.12812 0.803125L7.73625 1.53813C7.86313 1.68687 7.9375 1.88375 7.9375 2.09375V7.5625C7.9375 8.04375 7.54375 8.4375 7.0625 8.4375H0.9375C0.45625 8.4375 0.0625 8.04375 0.0625 7.5625V2.09375C0.0625 1.88375 0.136875 1.68687 0.26375 1.53813L0.8675 0.803125C0.99 0.654375 1.16937 0.5625 1.375 0.5625H6.625C6.83063 0.5625 7.01 0.654375 7.12812 0.803125ZM6.52 1.43848H1.48L1.13 1.86285H6.87438L6.52 1.43848ZM0.937515 7.56348V2.75098H7.06251V7.56348H0.937515ZM3.36564 3.62402H4.63439V4.93652H5.75002L4.00002 6.68652L2.25002 4.93652H3.36564V3.62402Z"
                          fill="#86879D"
                        />
                      </svg>
                    </span>
                  </button>
                  <div *ngIf="documentStatus !== 'archive'">
                    <button
                      class="ui circular tiny button"
                      suiPopup
                      style="top: 2px"
                      [popupInverted]="true"
                      popupPlacement="bottom"
                      popupText="Edit"
                      *isPermitted="{
                        id: 'COMPANY_DETAILS_DOCUMENT_UPLOAD',
                        action: 'read'
                      }"
                      (click)="editDoc.emit(documentTypeId)"
                      [ngClass]="{ hidden: documentStatus == 'archive' }"
                    >
                      <span style="top: 6px; left: 7.5px">
                        <svg
                          width="10"
                          height="11"
                          viewBox="0 0 10 11"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_7429_37166)">
                            <path
                              d="M9.41422 1.08605C9.03631 0.708125 8.53387 0.5 7.99944 0.5C7.465 0.5 6.96254 0.708125 6.58463 1.08604L0.992934 6.67775C0.945356 6.72533 0.910884 6.78439 0.892837 6.84922L0.0145556 10.0046C-0.0233155 10.1407 0.0152197 10.2867 0.115395 10.3863C0.189614 10.4601 0.289067 10.5 0.390903 10.5C0.426489 10.5 0.462388 10.4951 0.497602 10.4851L3.65301 9.58881C3.78614 9.551 3.88934 9.44555 3.92426 9.31162C3.95918 9.1777 3.92063 9.03529 3.82291 8.93727L1.83362 6.94193L6.46868 2.30686L8.19246 4.03064L4.64415 7.5693C4.49139 7.72164 4.49106 7.96896 4.6434 8.12172C4.79573 8.27449 5.04309 8.2748 5.19583 8.12248L9.41418 3.91561C9.79211 3.5377 10.0002 3.03525 10.0002 2.50082C10.0002 1.96639 9.79211 1.46395 9.41422 1.08605ZM2.80092 9.01871L0.953891 9.54336L1.47118 7.68492L2.80092 9.01871ZM8.86215 3.36279L8.74565 3.47898L7.02112 1.75443L7.13709 1.63846C7.36743 1.40811 7.67368 1.28125 7.99944 1.28125C8.3252 1.28125 8.63143 1.40811 8.86178 1.63848C9.09213 1.86881 9.21899 2.17506 9.21899 2.50082C9.21899 2.82658 9.09213 3.13283 8.86215 3.36279Z"
                              fill="#86879D"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_7429_37166">
                              <rect
                                width="10"
                                height="10"
                                fill="white"
                                transform="translate(0 0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </button>
                  </div>
                </div>
                <button
                  class="ui circular tiny button"
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="Download"
                  *isPermitted="{
                    id: 'COMPANY_DETAILS_DOCUMENT_UPLOAD',
                    action: 'read'
                  }"
                  (click)="download.emit(document)"
                >
                  <span style="left: 4px">
                    <svg
                      width="16"
                      height="15"
                      viewBox="0 0 16 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 8.34961C8.32361 8.34961 8.58594 8.08729 8.58594 7.76367V0.585938C8.58594 0.262324 8.32361 0 8 0C7.67639 0 7.41406 0.262324 7.41406 0.585938V7.76367C7.41406 8.08729 7.67639 8.34961 8 8.34961Z"
                        fill="#86879D"
                      />
                      <path
                        d="M6.72478 10.7595C6.72578 10.7605 6.72674 10.7615 6.72774 10.7625C7.07054 11.1053 7.52078 11.2766 7.97101 11.2766C8.42089 11.2766 8.87072 11.1055 9.21285 10.7633L12.4565 7.53235C12.6858 7.30398 12.6865 6.93299 12.4581 6.70372C12.2298 6.47447 11.8588 6.47371 11.6295 6.70208L8.38503 9.93387C8.27435 10.0445 8.12722 10.1055 7.97072 10.1055C7.81477 10.1055 7.66811 10.045 7.55757 9.93508L4.37432 6.70586C4.14715 6.47538 3.77614 6.47274 3.54569 6.69991C3.31524 6.92708 3.31257 7.29806 3.53974 7.52854L6.72478 10.7595Z"
                        fill="#86879D"
                      />
                      <path
                        d="M14.9141 12.0703C14.5904 12.0703 14.3281 12.3326 14.3281 12.6562C14.3281 13.3024 13.8024 13.8281 13.1562 13.8281H2.84375C2.19758 13.8281 1.67188 13.3024 1.67188 12.6562C1.67188 12.3326 1.40955 12.0703 1.08594 12.0703C0.762324 12.0703 0.5 12.3326 0.5 12.6562C0.5 13.9486 1.55141 15 2.84375 15H13.1562C14.4486 15 15.5 13.9486 15.5 12.6562C15.5 12.3326 15.2377 12.0703 14.9141 12.0703Z"
                        fill="#86879D"
                      />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div class="ui divider"></div>
        </div>
      </div>

      <div
        *ngIf="documentStatus == 'archive'"
        class="ui vertical basic segment"
      >
        <div class="ui two column grid">
          <div class="column middle aligned">
            <div class="ui icon small button">
              <i class="database icon"></i>
            </div>
            <a class="ui basic label"> {{ getArchivedCount() }} Record(s)</a>
          </div>
          <div
            class="column right aligned pagination menu"
            style="margin-left: auto"
          >
            <sui-pagination
              class="small"
              [collectionSize]="getArchivedCount()"
              [pageSize]="2"
              [maxSize]="maxSize"
              [hasEllipses]="false"
              [page]="page"
              (pageChange)="nextPage($event)"
            >
            </sui-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="ui vertical basic segment" appMargin="0" appPadding="0">
      <div
        *ngIf="documentStatus == 'history'"
        class=""
        style="overflow-x: hidden"
      >
        <div
          *ngIf="historyDocuments && historyDocuments?.length < 1"
          style="width: 50%; margin: 0 auto"
          class="no-record"
        >
          <h3
            style="
              font-size: 18px;
              font-weight: 700;
              margin-top: 2.5rem;
              text-align: center;
            "
          >
            This section has no uploaded document
          </h3>
        </div>

        <app-advanced-search-filter
          *ngIf="historyDocuments?.length > 1"
        ></app-advanced-search-filter>

        <div *ngFor="let document of historyDocuments">
          <!-- <div
        class="ui message"
        style="
          background-color: #fff2e2;
          display: flex;
          width: 389px;
          position: absolute;
          right: 0;
          padding: 2px 4px 2px 4px;
          top: 1.6rem;
          margin-top: 2.4rem;
        "
      >
        <h6 style="font-size: 10px; font-weight: 400">
          <span style="margin-right: 9px; margin-left: 5px; margin-top: 3px"
            ><svg
              width="12"
              height="11"
              viewBox="0 0 12 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.99915 4.7507V6.6257M1.34753 8.31352C0.914839 9.06352 1.45612 10.0007 2.32199 10.0007H9.67632C10.5422 10.0007 11.0835 9.06352 10.6508 8.31352L6.97361 1.93977C6.54068 1.18935 5.45763 1.18935 5.02469 1.93977L1.34753 8.31352ZM5.99915 8.1257H6.0029V8.12945H5.99915V8.1257Z"
                stroke="#505050"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              /></svg></span
          >The document(s) you've submitted for verification will be visible
          under the verified tab upon NCC's approval.
        </h6>
      </div> -->

          <div
            *ngIf="document != null"
            class="ui basic segment"
            appMargin
            marginB="3"
          >
            <div
              fxLayout="row"
              appPadding
              paddingR="0"
              fxLayoutGap="35px"
              fxLayoutAlign="start"
            >
              <div fxFlex="169px" class="content">
                <div class="top">Date Added</div>
                <div class="bottom">
                  {{ document?.dateCreated | date: "d MMM, y h:mm a" || "--" }}
                </div>
              </div>
              <div fxFlex="169px" class="content">
                <div class="top">Date Verified</div>
                <div class="bottom">
                  {{
                    (document?.dateApproved | date: "d MMM, y h:mm a") || "--"
                  }}
                </div>
              </div>
              <div class="content" style="width: fit-content !important">
                <div class="top">Added By</div>
                <div class="bottom" style="white-space: nowrap">
                  {{ returnJSON(document?.createdBy).name }}
                </div>
              </div>
              <div fxFlex="93px" class="content">
                <div class="top">Status</div>
                <div class="bottom">
                  <label
                    style="font-weight: 300"
                    class="ui tiny circular label"
                    [ngClass]="{
                      'label-green': document?.status == 'VERIFIED',
                      'label-red': document?.status == 'UNVERIFIED',
                      'label-orange': document?.status == 'PENDING',
                      'label-grey': document?.status == 'DISCARDED'
                    }"
                    >{{ (document.status ? document.status : "") | uppercase }}
                  </label>
                </div>
              </div>
              <!-- <div *ngIf="documentStatus != 'archive'" fxFlex="290px"></div> -->
              <div
                fxFlex="20px"
                class="content btn-holder"
                fxLayout="row"
                fxLayoutAlign="end center"
                fxLayoutGap="8px"
              >
                <div
                  class="ui circular tiny button"
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="View"
                  *isPermitted="{
                    id: 'COMPANY_DETAILS_DOCUMENT_UPLOAD',
                    action: 'read'
                  }"
                  (click)="history.emit(document)"
                >
                  <span style="top: 7px; left: 5.5px">
                    <svg
                      width="14"
                      height="11"
                      viewBox="0 0 14 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 6.99854C7.99414 6.99854 8.80005 6.19263 8.80005 5.19849C8.80005 4.20435 7.99414 3.39844 7 3.39844C6.00586 3.39844 5.19995 4.20435 5.19995 5.19849C5.19995 6.19263 6.00586 6.99854 7 6.99854Z"
                        fill="#86879D"
                      />
                      <path
                        d="M13.7232 5.04714C13.1939 3.67804 12.275 2.49404 11.0802 1.64148C9.88531 0.788915 8.46681 0.305159 7 0.25C5.53319 0.305159 4.11469 0.788915 2.91983 1.64148C1.72496 2.49404 0.806097 3.67804 0.276809 5.04714C0.241064 5.14601 0.241064 5.25427 0.276809 5.35314C0.806097 6.72224 1.72496 7.90624 2.91983 8.7588C4.11469 9.61136 5.53319 10.0951 7 10.1503C8.46681 10.0951 9.88531 9.61136 11.0802 8.7588C12.275 7.90624 13.1939 6.72224 13.7232 5.35314C13.7589 5.25427 13.7589 5.14601 13.7232 5.04714ZM7 8.12522C6.42147 8.12522 5.85594 7.95367 5.37491 7.63226C4.89388 7.31084 4.51897 6.85401 4.29758 6.31952C4.07618 5.78503 4.01826 5.19689 4.13112 4.62948C4.24399 4.06207 4.52257 3.54087 4.93165 3.13179C5.34073 2.72271 5.86193 2.44413 6.42934 2.33126C6.99676 2.2184 7.58489 2.27632 8.11938 2.49772C8.65387 2.71911 9.11071 3.09402 9.43212 3.57505C9.75353 4.05608 9.92508 4.62161 9.92508 5.20014C9.92389 5.97555 9.61533 6.71887 9.06703 7.26717C8.51873 7.81547 7.77541 8.12403 7 8.12522Z"
                        fill="#86879D"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
            <div class="ui divider"></div>
          </div>
        </div>
        <div class="ui vertical basic segment">
          <div class="ui two column grid">
            <div class="column middle aligned">
              <div class="ui icon small button">
                <i class="database icon"></i>
              </div>
              <a class="ui basic label"
                >{{ historyDocuments?.length }} Record(s)</a
              >
            </div>
            <div
              class="column right aligned pagination menu"
              style="margin-left: auto"
            >
              <sui-pagination
                class="small"
                [collectionSize]="historyDocuments?.length"
                [pageSize]="2"
                [maxSize]="maxSize"
                [hasEllipses]="false"
                [page]="page"
                (pageChange)="nextPage($event)"
              >
              </sui-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
